import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/unidriver-core';

export interface SidebarHeaderUniDriver extends BaseUniDriver {
  getTitle: () => Promise<string>;
  getSubtitle: () => Promise<string>;
  getChildren: () => UniDriver;
}
